import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { InquirySchema } from 'commons/Inquiry';
// 多言語対応のためスキーマをフック化
export const useInquirySchema = () => {
  const { t } = useTranslationWithLang('userEditDelete');

  const schema = InquirySchema({
    RequiredMessage: t('Validate_Required'),
    MailMessage: t('Validate_Mail'),
    PhoneNumberMessage: t('Validate_PhoneNumber'),
    KanaMessage: t('Validate_Kana'),
    MaxLengthMessage: (max: number) => t('Validate_MaxLength', { max }),
  });
  return schema;
};
